import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Refresh, AccessTime } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { GeneralError } from '../../Utility/Constants';
import ReportsCarrier from '../../Reports/ReportsCarrier';
import { getMmt1ScenarioDetailsData, clearData } from '../../Redux/MMTReports/MMT1Slice';
import { Mmt1ScenarioColumns } from '../../Table/TableColumn';
import Spinner from '../../Spinner/Spinner';
import ReportsTable from '../../Table/ReportsTable';

function MMT1() {
    const dispatch = useDispatch();
    const isLoadDataLoading = useSelector(state => state.mmt1.loadData.loading);
    const loadDataError = useSelector(state => state.mmt1.loadData.error);
    const lastRefreshedDate = useSelector(state => state.mmt1.loadData.lastRefreshedDate);
    const [initialFetchDone, setInitialFetchDone] = useState(false);

    useEffect(() => {
        if (loadDataError) {
            toast.error(GeneralError);
        }
    }, [loadDataError]);

    const handleRefresh = () => {
        dispatch(getMmt1ScenarioDetailsData());
    };

    useEffect(() => {
        dispatch(clearData());
        dispatch(getMmt1ScenarioDetailsData()).finally(() => setInitialFetchDone(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Databricks run handled via ReportsCarrier Start New Run button with selected carriers

    return (
        <>
            {(!initialFetchDone && isLoadDataLoading) && <Spinner />}
            <Box sx={{ margin: '20px 0' }}>
                <ReportsCarrier tabIndex={0} />
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '16px',
                gap: 2
            }}>
                <Button
                    variant="outlined"
                    size="small"
                    disabled={true}
                    startIcon={<AccessTime />}
                    sx={{ minWidth: '180px', fontWeight: 'bold' }}
                >
                    {`Last Updated: ${lastRefreshedDate ? lastRefreshedDate.split('.')[0] : ''}`}
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleRefresh}
                    disabled={isLoadDataLoading}
                    startIcon={<Refresh />}
                    sx={{ minWidth: '120px', fontWeight: 'bold' }}
                >
                    {isLoadDataLoading ? 'Refreshing...' : 'Refresh'}
                </Button>
            </Box>
            <ReportsTable
                tableName={'Scenario Details'}
                tableIndex={0}
                columns={Mmt1ScenarioColumns}
                dataSource={'loadData'}
                loading={isLoadDataLoading}
                sliceName={'mmt1'}
            />
        </>
    );
}

export default MMT1;